import { render, staticRenderFns } from "./LoanAccountTransfer.vue?vue&type=template&id=6a898591"
import script from "./LoanAccountTransfer.vue?vue&type=script&lang=js"
export * from "./LoanAccountTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports